import { render, staticRenderFns } from "./Location.vue?vue&type=template&id=60d707da&scoped=true&"
import script from "./Location.vue?vue&type=script&lang=js&"
export * from "./Location.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d707da",
  null
  
)

export default component.exports